var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 76,
    viewBox: "0 0 49 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5167 56.1083C14.5542 50.3333 11.9875 44.8791 7.81666 40.7083C3.64583 36.5375 1.07916 30.7625 1.07916 24.6666C1.07916 10.8708 12.95 0.283313 26.7458 1.56665C37.3333 2.52915 45.675 11.1916 47.2792 21.4583C48.2417 28.5166 45.9958 35.2541 41.5042 40.0666C37.3333 44.5583 34.4458 50.0125 33.1625 56.1083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1208 70.5459C18.0833 73.7542 20.9708 76.0001 24.5 76.0001C28.0292 76.0001 30.9167 73.7542 31.8792 70.5459H17.1208Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0875 69.5834H13.9125C12.6292 69.5834 11.6667 68.6209 11.6667 67.3375V58.675C11.6667 57.3917 12.6292 56.4292 13.9125 56.4292H34.7667C36.05 56.4292 37.0125 57.3917 37.0125 58.675V67.3375C37.3333 68.6209 36.3708 69.5834 35.0875 69.5834Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 56.1083V30.7625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1958 30.7624L20.0083 26.2708L24.5 30.7624L28.9917 26.2708L33.8042 30.7624",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.539ba85d797111d06b083fc93b1273f0.svg";
export { ForwardRef as ReactComponent };